// Iterates through an array of server transactions and formats them into log item
// objects (in Tx class fields format). It returns an object of arrays of log
// items, keyed by asset name.

export default function getAllLogItemsByAsset({
  getLogItemsFromServerTx,
  allTransactionsFromServer,
  ourWalletAddress,
  asset,
  tokensByAddress,
  assets,
}) {
  const allAssets = [asset, ...tokensByAddress.values()]
  const logItemsByAsset = Object.fromEntries(allAssets.map((asset) => [asset.name, []]))

  allTransactionsFromServer.forEach((serverTx) => {
    const logItemsByAssetForServerTx = getLogItemsFromServerTx({
      serverTx,
      ourWalletAddress,
      tokensByAddress,
      asset,
      assets,
    })

    Object.entries(logItemsByAssetForServerTx).forEach(([assetName, logItem]) => {
      logItemsByAsset[assetName].push(logItem)
    })
  })

  return logItemsByAsset
}
